import {
  IndicatorDetails,
  SectionIndicators,
} from '../../../../ReportBuilder/Components/IndicatorDetails/utils';
import {
  IndicatorByService,
  IndicatorSectionKey,
  indicatorSectionsInOrder,
  IndicatorWithUpdate,
} from '../../../../ReportBuilder/Components/ImpactIndicator/utils';
import { logError } from 'shared/utils/logError';

export type LocalDeletedIndicators = {
  [sectionKey in IndicatorSectionKey]: {
    [id: number]:
      | {
          impactDetail: IndicatorDetails;
          impactSummary: IndicatorWithUpdate;
        }
      | undefined;
  };
};

type SetDeletedIndicators = React.Dispatch<
  React.SetStateAction<LocalDeletedIndicators>
>;

export const deleteImpactSummaryIndicators = (
  sectionKey: IndicatorSectionKey,
  impactSummaryIndicators: IndicatorWithUpdate[],
  impactDetailIndicators: IndicatorDetails[],
  setDeletedIndicators: SetDeletedIndicators,
) => {
  setDeletedIndicators(s => {
    const newState = { ...s };
    impactSummaryIndicators.forEach(indicator => {
      newState[sectionKey][indicator.id] = {
        impactSummary: indicator,
        impactDetail: impactDetailIndicators.find(
          i => i.indicatorId === indicator.id,
        ) || {
          indicatorId: indicator.id,
          indicatorDefinition: indicator.definition,
          indicatorName: indicator.name,
          stageId: indicator.stageId,
          measurement: '',
          forecast: '',
          finalForecast: '',
          file: undefined,
          relevant: false,
        },
      };
    });
    return newState;
  });
};

const DELETED_INDICATORS_KEY = 'deletedIndicators';
const getDeletedIndicatorsBase = (): {
  [reportId: number]: LocalDeletedIndicators;
} => {
  try {
    const data = localStorage.getItem(DELETED_INDICATORS_KEY);
    return data ? JSON.parse(data) : {};
  } catch (e) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    logError(e as any);
    return {};
  }
};

export const getDeletedIndicatorsFromLocalStorage = (
  reportId: number | string | undefined,
): LocalDeletedIndicators => {
  const data = getDeletedIndicatorsBase();
  const id = Number(reportId);
  return reportId && data[id]
    ? data[id]
    : {
        act: {},
        learn: {},
        reach: {},
        succeed: {},
        catalyzed: {},
        capacityDevelopment: {},
      };
};

export const setDeletedIndicatorsToLocalStorage = (
  reportId: number,
  deletedIndicators: LocalDeletedIndicators,
) => {
  const deleted = getDeletedIndicatorsBase();
  localStorage.setItem(
    DELETED_INDICATORS_KEY,
    JSON.stringify({ ...deleted, [reportId]: deletedIndicators }),
  );
};

export const decoupleIndicators = (
  impactSummary: IndicatorByService,
  impactDetails: SectionIndicators,
  a: IndicatorByService,
) => {
  const allIndicators = { ...a };
  const i: IndicatorByService = {
    act: [],
    capacityDevelopment: [],
    catalyzed: [],
    learn: [],
    reach: [],
    succeed: [],
  };
  const i2: SectionIndicators = {
    act: [],
    capacityDevelopment: [],
    catalyzed: [],
    learn: [],
    reach: [],
    succeed: [],
  };
  indicatorSectionsInOrder.map(k => {
    impactSummary[k].forEach(impact => {
      const indicator = impactDetails[k].find(x => x.indicatorId === impact.id);
      if (indicator) {
        i[k].push(impact);
        i2[k].push(indicator);
        const index = allIndicators[k].findIndex(x => x.id === impact.id);
        if (index !== -1) {
          allIndicators[k].splice(index, 1);
        }
      }
    });
  });
  return {
    allIndicators,
    i,
    i2,
  };
};
